const comsteKefy = _this => {
  // _this.$t('noticeInfo._Perguntasdojogo')

  return [
    {
      questionList: [
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmensEscaneie'),
          createTime: 1714580903,
          id: 17876061,
          sort: 10,
          state: 1,
          title: _this.$t('noticeInfo._menCmensEscaneie_title'),
          updateBy: 'xp99',
          updateTime: 1715144453,
          videoUrl: ''
        },
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmensClique'),
          createTime: 1714580903,
          id: 17876062,
          sort: 9,
          state: 1,
          title: _this.$t('noticeInfo._menCmensClique_title'),
          updateBy: 'xp99',
          updateTime: 1715144457,
          videoUrl: ''
        },
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmensrendimento'),
          createTime: 1714580903,
          id: 17876064,
          sort: 8,
          state: 1,
          title: _this.$t('noticeInfo._menCmensrendimento_title'),
          updateBy: 'xp99',
          updateTime: 1715144460,
          videoUrl: ''
        },
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmenscliqueverificar'),
          createTime: 1714580903,
          id: 17876063,
          sort: 7,
          state: 1,
          title: _this.$t('noticeInfo._menCmenscliqueverificar_title'),
          updateBy: 'xp99',
          updateTime: 1715144463,
          videoUrl: ''
        }
      ],
      typeIcon: require('./../../../assets/icons/images/other_wt_icon.png'),
      typeId: 17630595,
      typeName: _this.$t('noticeInfo._Outrasperguntas')
    },
    {
      questionList: [
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmensVoce'),
          createTime: 1714580903,
          id: 17876060,
          sort: 11,
          state: 1,
          title: _this.$t('noticeInfo._menCmensVoce_title'),
          updateBy: 'xp99',
          updateTime: 1715144450,
          videoUrl: ''
        }
      ],
      typeIcon: require('./../../../assets/icons/images/withdraw_wt_icon.png'),
      typeId: 17630557,
      typeName: _this.$t('noticeInfo._PerguntasSobrecoleao')
    },
    {
      questionList: [
        {
          agentId: 12345,
          content: _this.$t('noticeInfo._menCmensApos'),
          createTime: 1714580903,
          id: 17876059,
          sort: 12,
          state: 1,
          title: _this.$t('noticeInfo._menCmensApos_title'),
          updateBy: 'xp99',
          updateTime: 1715144447,
          videoUrl: ''
        }
      ],
      typeIcon: require('./../../../assets/icons/images/pay_wt_icon.png'),
      typeId: 17630546,
      typeName: _this.$t('noticeInfo._Perguntasderecarga')
    },
    {
      questionList: [],
      typeIcon: require('./../../../assets/icons/images/game_wt_icon.png'),
      typeId: 17630510,
      typeName: _this.$t('noticeInfo._Perguntasdojogo')
    }
  ];
};
export { comsteKefy };
